// @flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import { siteActions } from "../../../redux/actions/siteActions";

import { createHashHistory } from "history";
import isEmpty from "lodash.isempty";
import Pagination from "react-js-pagination";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

import {
  DropdownButton,
  MenuItem,
  ButtonGroup,
} from "react-bootstrap";
import "../../../style/listPage.scss";
let rand = require("random-key");
import {aclUtil} from "../../util"
const history = createHashHistory();

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterType: "",
      filterText: "",
      searchData: [],
      activePage: 1,
      path: ["Home", "Search"],
      links:["home", ""],
      total: 0,
      per_page: 20,
      from: 0,
      limit: 20,
      search: "",
      tableColumns: {
        'customerEmail' : [
          {
            'tblColumnLabel' : 'ID',
            'tblColumnKey' : 'user_id'
          },
          // {
          //   'tblColumnLabel' : 'Company Name',
          //   'tblColumnKey' : 'siteName'
          // },
          {
            'tblColumnLabel' : 'First Name',
            'tblColumnKey'   : 'firstName'
          },
          {
            'tblColumnLabel' : 'Last Name',
            'tblColumnKey'   : 'lastName'
          },
          {
            'tblColumnLabel' : 'City',
            'tblColumnKey'   : 'title'
          },
          {
            'tblColumnLabel' : 'Email',
            'tblColumnKey'   : 'email'
          },
          {
            'tblColumnLabel' : 'Phone',
            'tblColumnKey' : 'phone'
          },
          {
            'tblColumnLabel' : 'Action',
            'tblColumnKey' : ''
          }
        ],
        'offers' : [
          {
            'tblColumnLabel' : 'ID',
            'tblColumnKey' : 'deal_id'
          },
          {
            'tblColumnLabel' : 'Company Name',
            'tblColumnKey' : 'siteName'
          },
          {
            'tblColumnLabel' : 'Offer Text',
            'tblColumnKey'   : 'mainDealText'
          },
          {
            'tblColumnLabel' : 'Price',
            'tblColumnKey'   : 'offerPrice'
          },
          {
            'tblColumnLabel' : 'Original Price',
            'tblColumnKey'   : 'retailPrice'
          },
          {
            'tblColumnLabel' : 'Max Offers',
            'tblColumnKey'   : 'maxAvailable'
          },
          {
            'tblColumnLabel' : 'Merchant',
            'tblColumnKey' : 'merchantName'
          },
          {
            'tblColumnLabel' : 'City',
            'tblColumnKey' : 'dealCities'
          }
        ],
        'orderID' : [
          {
            'tblColumnLabel' : 'ID',
            'tblColumnKey' : 'order_id'
          },
          {
            'tblColumnLabel' : 'Company Name',
            'tblColumnKey' : 'siteName'
          },
          {
            'tblColumnLabel' : 'Transaction ID',
            'tblColumnKey'   : 'payment_id'
          },
          {
            'tblColumnLabel' : 'Grand Total',
            'tblColumnKey'   : 'discount_amount'
          },
          {
            'tblColumnLabel' : 'Discount Amount',
            'tblColumnKey'   : 'grand_total'
          },
          {
            'tblColumnLabel' : 'Store Credits',
            'tblColumnKey'   : 'store_credit'
          },
          {
            'tblColumnLabel' : 'Shipping Amount',
            'tblColumnKey' : 'shipping'
          },
          {
            'tblColumnLabel' : 'Tax Amount',
            'tblColumnKey' : 'tax'
          }
        ],
        'vouchers' : [
          {
            'tblColumnLabel' : 'ID',
            'tblColumnKey' : 'voucher_id'
          },
          {
            'tblColumnLabel' : 'Company Name',
            'tblColumnKey' : 'siteName'
          },
          {
            'tblColumnLabel' : 'Deal',
            'tblColumnKey'   : 'mainDealText'
          },
          {
            'tblColumnLabel' : 'User',
            'tblColumnKey'   : 'fullName'
          },
          {
            'tblColumnLabel' : 'Voucher number',
            'tblColumnKey'   : 'voucherNumber'
          },
          {
            'tblColumnLabel' : 'Expired at',
            'tblColumnKey'   : 'expiryDate'
          },
          {
            'tblColumnLabel' : 'Status',
            'tblColumnKey' : 'status'
          }
        ]
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if(this.props.match && this.props.match.params.filterText){
      this.setState({
        filterType:this.props.match.params.filterType,
        filterText:this.props.match.params.filterText
      });

      const {actions: { getCustomerData } } = this.props;
      let postData = {
        searchBy:this.props.match.params.filterType, 
        searchKey: this.props.match.params.filterText,
        page: this.state.activePage,
        limit: this.state.limit,
        search: this.state.search,
        site_id: localStorage.getItem("siteID")
      }
      getCustomerData(postData);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.match && nextProps.match.params.filterText && (nextProps.match.params.filterText != this.state.filterText || nextProps.match.params.filterType != this.state.filterType)){
      this.setState({
        filterType:nextProps.match.params.filterType,
        filterText:nextProps.match.params.filterText,
        activePage: 1,
        page: 1
      });
      const {actions: { getCustomerData } } = this.props;
      let postData = {
        searchBy:nextProps.match.params.filterType, 
        searchKey: nextProps.match.params.filterText,
        page: 1,
        limit: this.state.limit,
        search: this.state.search,
        site_id: localStorage.getItem("siteID")
      }
      getCustomerData(postData);
    }

    if(!isEmpty(nextProps.searchData)){

      this.setState({searchData: nextProps.searchData.data, total: nextProps.searchData.total, per_page : nextProps.searchData.per_page, from : nextProps.searchData.from});
    }
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };


  handlePageChange = pageNumber => {
    const postData = {
      page: pageNumber,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : "",
      searchBy:this.state.filterType, 
      searchKey: this.state.filterText,
      site_id: localStorage.getItem("siteID")
    };

    const {actions: { getCustomerData } } = this.props;
    getCustomerData(postData);
    this.setState({ activePage: pageNumber });
  }

  renderActionButtons = (userId) => {
    return <ButtonGroup key={userId}>
      <DropdownButton title="Action" id="bg-nested-dropdown">
        {aclUtil.checkACL('DASHBOARD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/addSubAdmin/${userId}`)}><i className="fa fa-pencil-square-o"></i> Edit Details</MenuItem>) : ("")}
        {aclUtil.checkACL('DASHBOARD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/voucherList/${userId}`)}><i className="fa fa-eye"></i> Offers Purchased</MenuItem>) : ("")}
        {aclUtil.checkACL('DASHBOARD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/orders/${userId}`)}><i className="fa fa-eye"></i> Order History</MenuItem>) : ("")}
        {aclUtil.checkACL('DASHBOARD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/store-credit/${userId}`)}><i className="fa fa-eye"></i> Credits</MenuItem>) : ("")}
      </DropdownButton>
    </ButtonGroup>
  }

  render() {
    const {filterType, tableColumns} = this.state;
    let tmpfilterType = (filterType == 'customerName') ? "customerEmail" : filterType ;
    let searchData = this.state.searchData ? this.state.searchData : [];
    let searchContent, tableHeader;

    

    if (!isEmpty(searchData)) {
      searchContent = searchData.map((row, index) => {
        return (<tr key={row.userID + "" + index} >
          {
            tableColumns[tmpfilterType].map((rowC, indexC) => {
              return (
                (tmpfilterType && rowC.tblColumnLabel == 'Action' && (tmpfilterType == 'customerName' || tmpfilterType == 'customerEmail'))?
                (<td key={tmpfilterType + "" + indexC}>{this.renderActionButtons(row.userID)}</td>):(<td key={tmpfilterType + "" + indexC}>{row[rowC.tblColumnKey]}</td>)
              )
            })
          }
        </tr>)
      });
    }
    if (isEmpty(searchData)) {
      searchContent = <tr key='noRec1' >
                        <td colSpan="6" style={{'textAlign': 'center'}}><b>No Record Found...</b></td>
                      </tr>
    }
    if (!isEmpty(tableColumns[tmpfilterType])) {
      tableHeader = tableColumns[tmpfilterType].map((row, index) => (
         <th key={"tblHeader" + index} >{row.tblColumnLabel}</th>
      ));
    }
    return (
      <div>
        <div className="col-xs-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Search</header>
            <div className="panel-body">
              <div className="clearfix" />
              <div className="col-lg-12 site-list">
                <table className="table table-hover" responsive="true">
                  <thead>
                    <tr>
                      {tableHeader}
                      {/*<th>Actions{" "}</th>*/}
                    </tr>
                  </thead>
                  <tbody>{searchContent}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.siteReducer.loading,
    error: state.siteReducer.error,
    siteList:  state.siteReducer.siteList,
    searchData: state.siteReducer.searchData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions
      },
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);



// WEBPACK FOOTER //
// ./src/app/views/admin/dashboard/Search.js